import { EventDrag, GridFeatureManager } from "@bryntum/schedulerpro";
import type { FinalizeContext } from "./FinalizeContext";
import ProjectQueueHoldMixin from "./mixins/ProjectQueueHoldMixin";

/**
 * Replaces Bryntum's default `EventDrag` feature for `SchedulerPro`.
 *
 * Holds `project.crudQueue.queue()` from drag start through finalization, so CRUD
 * work queued during the gesture waits behind it. Invalid drops, aborts and
 * teardown release the hold without finalization work.
 */
export default class SwivuEventDrag extends ProjectQueueHoldMixin(EventDrag) {
  static $name = "EventDrag";

  construct(...args: object[]) {
    super.construct(...args);

    this.client.on({
      eventDragStart: () => this.holdProjectQueue(),
      beforeEventDropFinalize: ({ context }: { context: FinalizeContext }) => {
        context.async = true;
        this.runWithProjectQueue(() => context.finalize(true));
      },
      afterEventDrop: () => this.cancelProjectQueue(),
      eventDragAbort: () => this.cancelProjectQueue(),
      thisObj: this
    });
  }
}

GridFeatureManager.registerFeature(SwivuEventDrag, true, "SchedulerPro");
